<template>
  <div class="finished">
    <div class="icon-container">
      <transition name="slide-fade">
        <img v-show="iconVisible" src="@/assets/finish.svg" />
      </transition>
    </div>

    <span class="message">お疲れ様でした、すべてのテストが終了しました。</span>
    <button class="button" @click="goToResult">テストの結果を確認する</button>
  </div>
</template>

<script>
export default {
  name: "Finished",
  data() {
    return {
      iconVisible: false
    };
  },
  methods: {
    goToResult() {
      this.$emit("show-result");
    }
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      self.iconVisible = true;
    }, 600);
  }
};
</script>

<style scoped>
.finished {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  margin: auto;
  height: 100%;
  width: 100%;
}
.message {
  display: inline-block;
  font-size: 1.6rem;
  margin-bottom: 30px;
}

.icon-container {
  min-height: 148px;
}
img {
  width: 110px;
  height: 110px;
  margin-bottom: 30px;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
